var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDriversLicense = function SvgDriversLicense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 42,
    rx: 5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 10,
    width: 21.3165,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 16,
    width: 15.7674,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 13,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1525 22.72C12.4392 21.6707 13.3635 20.9918 14.2655 21.0071C14.6611 20.9995 16.398 20.9995 18.2243 21.0004C20.0506 20.9995 21.7875 20.9995 22.1831 21.0071C23.0851 20.9918 24.0094 21.6707 24.2961 22.72L25.0008 25.3027C25.5111 25.3314 25.9174 25.7467 25.9174 26.2556C25.9174 26.5888 25.7424 26.8829 25.478 27.0538C25.7998 27.3374 26 27.7298 26 28.1681V29.6002C26 29.8237 25.9475 30.0347 25.8552 30.2228C25.7473 30.4347 25.7521 30.6849 25.8668 30.893C25.9543 31.0382 26 31.2091 26 31.3905C26 31.9423 25.5743 32.3978 25.028 32.4579V32.942C25.028 33.7316 24.3749 34.3742 23.5701 34.3742C22.7653 34.3742 22.1121 33.7316 22.1121 32.942V32.508H14.3365V32.942C14.3365 33.7316 13.6833 34.3742 12.8785 34.3742C12.0737 34.3742 11.4206 33.7316 11.4206 32.942V32.4579C10.8743 32.3978 10.4486 31.9423 10.4486 31.3905C10.4486 31.2091 10.4943 31.0391 10.575 30.8892C10.6877 30.683 10.6916 30.4366 10.5847 30.2266C10.5011 30.0347 10.4486 29.8227 10.4486 29.6002V28.1681C10.4486 27.7374 10.642 27.3517 10.9472 27.0891C10.6498 26.9259 10.4486 26.6137 10.4486 26.2556C10.4486 25.7286 10.884 25.3018 11.4196 25.3018L12.1525 22.72ZM13.4003 28.6201C13.9153 28.6201 14.3333 29.0382 14.3333 29.5532C14.3333 30.0683 13.9153 30.4863 13.4003 30.4863C12.8852 30.4863 12.4672 30.0683 12.4672 29.5532C12.4672 29.0382 12.8852 28.6201 13.4003 28.6201ZM23.0452 28.6201C23.5603 28.6201 23.9783 29.0382 23.9783 29.5532C23.9783 30.0683 23.5603 30.4863 23.0452 30.4863C22.5302 30.4863 22.1122 30.0683 22.1122 29.5532C22.1122 29.0382 22.5302 28.6201 23.0452 28.6201ZM22.1124 26.5985H22.6073C22.7911 26.5985 22.9651 26.5154 23.0769 26.3755C23.1897 26.2355 23.2267 26.0526 23.179 25.8819C22.9651 25.113 22.6306 23.9177 22.4546 23.287C22.3856 23.0388 22.1503 22.8661 21.8819 22.8661H18.2229H14.5639C14.2956 22.8661 14.0602 23.0388 13.9912 23.287C13.8152 23.9177 13.4807 25.113 13.2668 25.8819C13.2192 26.0526 13.2561 26.2355 13.3689 26.3755C13.4807 26.5154 13.6548 26.5985 13.8385 26.5985H14.3335C14.8994 26.5966 21.5464 26.5966 22.1124 26.5985Z",
    fill: "currentColor"
  })));
};
export { SvgDriversLicense as ReactComponent };